class ApiContacts {
    constructor(Restangular, ApiBaseResponseService) {
        return {
            /**
             * Get all contacts (with minimal inforamtion)
             * @return {Object}
             */
            getContacts() {
                return Restangular.one('contacts')
                    .get()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get all contacts with specific selection id
             * @return {Object}
             */
            getContactsForSelectionId(selectionId) {
                return Restangular.one('contacts/idsForSelection', selectionId)
                    .get()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get all package contacts
             * @return {Object}
             */
            getPackageContacts(filterObj) {
                return Restangular.all('contacts')
                    .all('filter')
                    .post(filterObj)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Email contacts
             */
            emailContacts(filterObj) {
                return Restangular.all('contacts')
                    .all('export')
                    .all('email')
                    .post(filterObj)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get all team (custom) contacts
             * @return {Object}
             */
            getTeamContacts(filterObj) {
                return Restangular.all('contacts')
                    .all('customerContacts')
                    .all('filter')
                    .post(filterObj)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get contact by Id
             * @return {Object}
             */
            getContact(contactId, param) {
                return Restangular.one('contacts', contactId)
                    .get(param)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getContactExtensionIds(contactId, param) {
                return Restangular.one('contacts', contactId)
                    .one('contactExtensionIds')
                    .get(param)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            postContact(contact) {
                return Restangular.all('contacts')
                    .all('customerContact')
                    .post(contact)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            putContact(contact) {
                return Restangular.one('contacts')
                    .one('customerContact', contact.contact.id)
                    .customPUT(contact)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            deleteContact(contactId) {
                return Restangular.one('contacts')
                    .one('customerContact', contactId)
                    .remove()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            checkContactAccess(
                userId,
                contactId,
                isCustomerContact,
                campaignId
            ) {
                return Restangular.one('contacts/checkUserContactAccess')
                    .get({
                        userId: userId,
                        contactId: contactId,
                        isCustomerContact: isCustomerContact,
                        campaignId: campaignId,
                    })
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getContactsCount(filter) {
                return Restangular.all('contacts/count')
                    .post(filter)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getCustomContactsCount(filter) {
                return Restangular.all('contacts/customerContacts/count')
                    .post(filter)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getContactCampaigns(contactId, filter) {
                return Restangular.one('contacts', contactId)
                    .customGET('campaigns', filter)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getCampaignIds(contactId, param) {
                return Restangular.one('contacts', contactId)
                    .one('campaignIds')
                    .get(param)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            putAdditionalInfo(additionalInfo) {
                return Restangular.one('contacts')
                    .one('additionalInfo')
                    .customPUT(additionalInfo)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },
            postAdditionalInfo(additionalInfo) {
                return Restangular.one('contacts/additionalInfo')
                    .customPOST(additionalInfo)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            postSavedSearch(savedSearch) {
                return Restangular.one('contacts')
                    .one('filter/saved')
                    .customPOST(savedSearch)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getSavedSearch() {
                return Restangular.one('contacts')
                    .one('filter/saved')
                    .get()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            deleteSavedSearch(name) {
                Restangular.one('contacts')
                    .one('filter/saved')
                    .one(encodeURIComponent(name))
                    .remove();
            },
        };
    }
}

ApiContacts.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiContacts;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiContacts.js
 **/